"use client";

import HeaderBackground from "@/components/ui/header-background";
import Breadcrumbs from "@/components/entities/breadcrumbs";
import TwoColumnsBlock from "@/components/ui/two-columns-block";
import { useTranslations } from "next-intl";
import { useTechnologiesPageData } from "../../hooks/useTechnologiesPageData";
import { Container } from "@/components/ui/container";
import S from "./index.module.scss";

const Header = () => {
  const t = useTranslations();
  const { technologiesPage } = useTechnologiesPageData();

  const breadcrumbs = [{ title: t("home"), url: "/" }];

  if (!technologiesPage.technologiesPage || technologiesPage.loading) return null;

  return (
    <>
      <HeaderBackground type="video" src={technologiesPage.technologiesPage.background} />
      <Container>
        <div className={S.headerWrapper}>
          <Breadcrumbs breadcrumbs={breadcrumbs} />
          <h1 className={S.title}>{t("technology")}</h1>
          <TwoColumnsBlock
            title={technologiesPage.technologiesPage.title}
            subtitle={technologiesPage.technologiesPage.description}
          />
        </div>
      </Container>
    </>
  );
};

export default Header;
